import AustinHeroImg from '@/assets/srp-banners/austin.png';
import DefaultHeroImg from '@/assets/srp-banners/default.png';
import HoustonHeroImg from '@/assets/srp-banners/houston.png';
import LosAngelesHeroImg from '@/assets/srp-banners/los-angeles.png';
import PhoenixHeroImg from '@/assets/srp-banners/phoenix.png';
import RainierHeroImg from '@/assets/srp-banners/rainier-default.png';
import SanDiegoHeroImg from '@/assets/srp-banners/san-diego.png';
import SanFranciscoHeroImg from '@/assets/srp-banners/san-francisco.png';
import SeattleHeroImg from '@/assets/srp-banners/seattle.png';
import YellowStoneHeroImg from '@/assets/srp-banners/yellowstone-default.png';

const textColorBlack = 'text-gray-900';
const textColorWhite = 'text-white';
const navWhite = 'od-header-nav-white';
const navTransparent = 'od-header-nav-transparent';

const headerDetails = (urlPath: string, regionCode?: string) => {
  const headerLocalityDetail = heroLocalityDetails.find(detail => detail.urlPath === urlPath);

  if (headerLocalityDetail) {
    return headerLocalityDetail;
  }

  return regionCodeHeaderDetails(regionCode);
};

const regionCodeHeaderDetails = (regionCode?: string) => {
  const defaultColor = 'green';
  const { color } = US_STATES.find(state => state.state === regionCode) || { color: defaultColor };

  return heroRegionCodeDetails.find(region => region.color === color);
};

const heroLocalityDetails = [
  {
    urlPath: '/rv-rental/texas/austin',
    imageUrl: AustinHeroImg,
    bgColor: 'bg-yellowstone',
    textColor: textColorBlack,
    headerClass: navTransparent,
  },
  {
    urlPath: '/rv-rental/texas/houston',
    imageUrl: HoustonHeroImg,
    bgColor: 'bg-yellowstone',
    textColor: textColorBlack,
    headerClass: navTransparent,
  },
  {
    urlPath: '/rv-rental/arizona/phoenix',
    imageUrl: PhoenixHeroImg,
    bgColor: 'bg-yellowstone',
    textColor: textColorBlack,
    headerClass: navTransparent,
  },
  {
    urlPath: '/rv-rental/washington/seattle',
    imageUrl: SeattleHeroImg,
    bgColor: 'bg-green-800',
    textColor: textColorWhite,
    headerClass: navWhite,
  },
  {
    urlPath: '/rv-rental/california/san-francisco',
    imageUrl: SanFranciscoHeroImg,
    bgColor: 'bg-green-800',
    textColor: textColorWhite,
    headerClass: navWhite,
  },
  {
    urlPath: '/rv-rental/california/san-diego',
    imageUrl: SanDiegoHeroImg,
    bgColor: 'bg-blue-800',
    textColor: textColorWhite,
    headerClass: navWhite,
  },
  {
    urlPath: '/rv-rental/california/los-angeles',
    imageUrl: LosAngelesHeroImg,
    bgColor: 'bg-blue-800',
    textColor: textColorWhite,
    headerClass: navWhite,
  },
];

const heroRegionCodeDetails = [
  {
    color: 'green',
    imageUrl: DefaultHeroImg,
    bgColor: 'bg-green-800',
    textColor: textColorWhite,
    headerClass: navWhite,
  },
  {
    color: 'orange',
    imageUrl: YellowStoneHeroImg,
    bgColor: 'bg-yellowstone',
    textColor: textColorBlack,
    headerClass: navTransparent,
  },
  {
    color: 'blue',
    imageUrl: RainierHeroImg,
    bgColor: 'bg-blue-800',
    textColor: textColorWhite,
    headerClass: navWhite,
  },
];

const US_STATES = [
  { state: 'AK', color: 'green' },
  { state: 'AZ', color: 'orange' },
  { state: 'AR', color: 'green' },
  { state: 'CA', color: 'orange' },
  { state: 'CO', color: 'orange' },
  { state: 'CT', color: 'blue' },
  { state: 'DE', color: 'blue' },
  { state: 'FL', color: 'green' },
  { state: 'GA', color: 'green' },
  { state: 'HI', color: 'blue' },
  { state: 'ID', color: 'green' },
  { state: 'IL', color: 'blue' },
  { state: 'IN', color: 'blue' },
  { state: 'IA', color: 'blue' },
  { state: 'KS', color: 'blue' },
  { state: 'KY', color: 'blue' },
  { state: 'LA', color: 'green' },
  { state: 'ME', color: 'blue' },
  { state: 'MD', color: 'blue' },
  { state: 'MA', color: 'blue' },
  { state: 'MI', color: 'blue' },
  { state: 'MN', color: 'blue' },
  { state: 'MS', color: 'green' },
  { state: 'MO', color: 'green' },
  { state: 'MT', color: 'blue' },
  { state: 'NE', color: 'green' },
  { state: 'NV', color: 'orange' },
  { state: 'NH', color: 'blue' },
  { state: 'NJ', color: 'blue' },
  { state: 'NM', color: 'orange' },
  { state: 'NY', color: 'blue' },
  { state: 'NC', color: 'green' },
  { state: 'ND', color: 'green' },
  { state: 'OH', color: 'blue' },
  { state: 'OK', color: 'orange' },
  { state: 'OR', color: 'green' },
  { state: 'PA', color: 'blue' },
  { state: 'RI', color: 'blue' },
  { state: 'SC', color: 'green' },
  { state: 'SD', color: 'green' },
  { state: 'TN', color: 'green' },
  { state: 'TX', color: 'orange' },
  { state: 'UT', color: 'orange' },
  { state: 'VT', color: 'blue' },
  { state: 'VA', color: 'blue' },
  { state: 'WA', color: 'green' },
  { state: 'WV', color: 'blue' },
  { state: 'WI', color: 'blue' },
  { state: 'WY', color: 'green' },
];

export default headerDetails;
